import React from 'react';

function Line({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      {...props}
      viewBox="0 0 400 1"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line y1="0.75" x2="400" y2="0.75" stroke="#929292" />
    </svg>
  );
}

export default Line;
